import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ClientScanJob,
  Dither,
  JSPrintManager,
  PixelMode,
  PrintRotation,
  PrinterIcon,
  ScannerImageFormatOutput,
  WSStatus,
} from 'jsprintmanager';
import { FormsModule } from '@angular/forms';
import {
  DxButtonModule,
  DxCheckBoxModule,
  DxLoadPanelModule,
  DxNumberBoxModule,
  DxSelectBoxModule,
  DxTextBoxModule,
} from 'devextreme-angular';
// Dashboard Faz0 Clara: eski hâli — kullanılmayan IDE otomatik-importu (devexpress paketini boşuna çekiyordu)
// import { ConversionPanelExtension } from 'devexpress-dashboard/designer';
import jsPDF from 'jspdf';
// Dashboard Faz0 Clara: eski hâli — kullanılmayan IDE otomatik-importu (devexpress paketini boşuna çekiyordu)
// import { DockingLayoutAdapter } from 'devexpress-dashboard/common/index.internal';

//js print manager

@Component({
  selector: 'dk-document-scanner3',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DxLoadPanelModule,
    DxButtonModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxNumberBoxModule,
  ],
  templateUrl: './document-scanner3.component.html',
  styleUrls: ['./document-scanner3.component.scss'],
})
export class DocumentScanner3Component implements OnInit, OnDestroy {
  @Output() base64Content: EventEmitter<string> = new EventEmitter<string>();

  isLoading = true;
  numOfScannerDevices = -1;
  scannerDevices: any[] = [];
  scannerName = '';
  //resolution = 200;
  //pixelMode='Color';
  dither = 'Threshold';
  threshold = 128;
  imageFormat = 'JPG';
  jpgQuality = 100;
  pdfTitle = '';
  enableDuplex = false;
  enableFeeder = false;
  feederCount = 0;
  showUI = false;
  showProgressUI = true;
  scanningState = 0; // 0 = finished, 1 = scanning, 2 = error
  error = '';
  scannedImages: string[] = [];
  curImgIndex = 0;

  documentResolutionTypes = [
    { value: 100, name: '100 DPI' },
    { value: 150, name: '150 DPI' },
    { value: 200, name: '200 DPI' },
    { value: 300, name: '300 DPI' },
  ];
  selectedDocumentResolution: number = 200;

  documentExportType = [
    { value: 0, name: 'PDF' },
    { value: 1, name: 'JPEG' },
    { value: 2, name: 'PNG' },
    { value: 3, name: 'BMP' },
    { value: 4, name: 'TIFF' },
  ];
  selectedDocumentExportType: string = 'PDF';

  selectedDocumentPixelType: string = 'Grayscale';

  documentPixelTypes = [
    { value: 'Grayscale', name: 'Gri', icon: 'edit' },
    { value: 'Color', name: 'Renkli', icon: 'edit' },
    { value: 'BlackAndWhite', name: 'Siyah/Beyaz', icon: 'edit' },
  ];

  base64Res: string;

  canSaveFile = false;

  rotateImage: PrintRotation;
  rotateVal = 0;
  constructor() {}

  ngOnDestroy(): void {
    JSPrintManager.stop();
  }

  ngOnInit(): void {
    // Equivalent to componentDidMount

    //JSPrintManager.caller = this.jsPrintManagerCaller.bind(this);
    // console.log(JSPrintManager)
    //  JSPrintManager.getScanners().then((scannersList: string[]) => {
    //   this.setScannerDevices(scannersList);
    // });
    //   JSPrintManager.auto_reconnect = true;
    JSPrintManager.start();
    JSPrintManager.WS.onStatusChanged = () => {
      if (this.jspmWSStatus()) {
        // get client installed printers
        JSPrintManager.getScanners().then((myPrinters: any) => {
          this.isLoading = false;
          myPrinters.forEach((name: any, index: any): any => {
            this.scannerDevices.push({ value: index, name: name });
            console.log('name', name);
            console.log('index', index);
            if (index === 0) {
              this.scannerName = name;
            }
          });
        });
      }
    };
  }

  jspmWSStatus() {
    if (JSPrintManager.websocket_status === WSStatus.Open) {
      return true;
    } else if (JSPrintManager.websocket_status === WSStatus.Closed) {
      //  alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
      return false;
    } else if (JSPrintManager.websocket_status === WSStatus.Blocked) {
      alert('JSPM has blocked this website!');
      return false;
    }
    return false;
  }

  setScannerDevices(scannersList: string[]): void {
    this.numOfScannerDevices = scannersList.length;
    this.scannerName = scannersList[0] || '';
    this.scannerDevices = scannersList;
  }

  setData(event: Event): void {
    const target = event.target as HTMLInputElement;
    const { name, value, checked } = target;
    (this as any)[name] = target.type === 'checkbox' ? checked : value;
  }

  // setImageFormat(event: Event): void {
  //   this.imageFormat = (event.target as HTMLInputElement).value;
  // }

  // setPixelMode(event: Event): void {
  //   this.selectedDocumentPixelType = ((event.target as HTMLInputElement).value) ;
  // }

  // setDither(event: Event): void {
  //   this.dither = (event.target as HTMLInputElement).value;
  // }

  // setThreshold(event: Event): void {
  //   this.threshold = parseInt((event.target as HTMLInputElement).value, 10);
  // }

  // setJpgQuality(event: Event): void {
  //   this.jpgQuality = parseInt((event.target as HTMLInputElement).value, 10);
  // }

  createScanJob(): any {
    const doc = new jsPDF('p', 'mm', 'a4');
    let pageCount = 0;

    const csj = new ClientScanJob();
    csj.scannerName = this.scannerName;
    csj.pixelMode =
      PixelMode[this.selectedDocumentPixelType as keyof typeof PixelMode];

    csj.dither = Dither[this.dither as keyof typeof Dither];
    csj.resolution = parseInt(this.selectedDocumentResolution.toString(), 10);
    csj.imageFormat =
      ScannerImageFormatOutput[
        this.imageFormat as keyof typeof ScannerImageFormatOutput
      ];
    csj.enableDuplex = this.enableDuplex;
    csj.enableFeeder = this.enableFeeder;
    csj.feederCount = parseInt(this.feederCount.toString(), 10);
    csj.jpgCompressionQuality = parseInt(this.jpgQuality.toString(), 10);
    csj.pdfTitle = this.pdfTitle;
    csj.showUI = this.showUI;
    csj.showProgressUI = this.showProgressUI;
    csj.threshold = this.threshold;

    csj.onUpdate = (data: any, last: boolean) => {
      this.scanningState = last ? 0 : 1;
      console.info(data);

      if (!(data instanceof Blob)) {
        return;
      }

      const imgBlob = new Blob([data]);
      if (imgBlob.size === 0) return;

      const dataType = this.imageFormat === 'PNG' ? 'image/png' : 'image/jpg';
      const img = URL.createObjectURL(imgBlob);

      const reader = new FileReader();
      reader.onload = () => {
        let base64String = reader.result as string;
        console.log('reader base64:', base64String);
        if (base64String.includes('data:application/octet-stream;base64,')) {
          base64String = base64String.replace(
            'data:application/octet-stream;base64,',
            ''
          );
        }
        let pdfResult;
        switch (this.selectedDocumentExportType) {
          case 'PDF':
            if (pageCount > 0) {
              doc.addPage();
            }
            pageCount++;

            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();

            doc.addImage(
              'data:image/jpeg;base64,' + base64String,
              'JPEG',
              0,
              0,
              pageWidth,
              pageHeight
            );
            console.log('last', last);
            //   if(last){

            base64String = 'data:application/pdf;base64,' + base64String;
            //  }

            break;
          case 'JPEG':
            base64String = 'data:image/jpeg;base64,' + base64String;
            break;
          case 'PNG':
            base64String = 'data:image/png;base64,' + base64String;
            break;
          case 'BMP':
            base64String = 'data:image/bmp;base64,' + base64String;
            break;
          case 'TIFF':
            base64String = 'data:image/tiff;base64,' + base64String;
            break;
          default:
            break;
        }
        this.scannedImages.push(base64String);
        if (this.selectedDocumentExportType === 'PDF') {
          pdfResult = doc.output('datauristring').split(',')[1];
          console.log('pdf base64:', pdfResult);
          this.base64Res = 'data:application/pdf;base64,' + pdfResult;
        } else {
          this.base64Res = base64String;
        }

        this.canSaveFile = true;
        console.log('total image length:', this.scannedImages.length);
        console.log('final base64 res:', this.base64Res);
      };
      reader.onerror = (error) => {
        console.error('Error converting blob to Base64:', error);
      };
      reader.readAsDataURL(imgBlob);
    };

    csj.onError = (data: any, isCritical: boolean) => {
      this.error = data;
      console.error(data);
      this.scanningState = 2;
    };

    return csj;
  }

  exportFileAsBase64Content() {
    this.base64Content.emit(this.base64Res);
  }

  downloadBase64Pdf(
    base64Pdf: string,
    fileName: string = 'download.pdf'
  ): void {
    // Ensure the Base64 string has the correct MIME prefix.
    // If it doesn't, you can prepend it:
    if (!base64Pdf.startsWith('data:application/pdf;base64,')) {
      base64Pdf = 'data:application/pdf;base64,' + base64Pdf;
    }

    // Create a temporary <a> element
    const link = document.createElement('a');
    link.href = base64Pdf;
    link.download = fileName;

    // Append to the body (required for Firefox)
    document.body.appendChild(link);

    // Trigger the download by simulating a click
    link.click();

    // Clean up and remove the element
    document.body.removeChild(link);
  }

  nextImage(): void {
    if (this.curImgIndex < this.scannedImages.length - 1) {
      this.curImgIndex++;
    }
  }

  prevImage(): void {
    if (this.curImgIndex > 0) {
      this.curImgIndex--;
    }
  }

  doScanning(): void {
    const csj = this.createScanJob();
    if (csj) {
      this.error = '';
      this.scanningState = 1;
      this.scannedImages = [];
      this.curImgIndex = 0;
      csj.sendToClient().then((data: any) => console.info(data));
    }
  }

  saveBlob(blob: Blob, fileName: string): void {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';

    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  getSelectedDevice($e: any) {
    this.scannerName = $e.name;

    // if (this.selectedScannerDevice) {
    //   this.scanButtonDisabled = false;
    // }
  }
  getSelectedResolutionType($e: any) {
    this.selectedDocumentResolution = $e.value;
  }

  getSelectedDocType($e: any) {
    this.selectedDocumentExportType = $e.name;
  }
  getSelectedPixelType($e: any) {
    this.selectedDocumentPixelType = $e.value;
  }

  changeImageContrast(incYn: boolean) {
    if (incYn) {
      this.threshold += 50;
    } else this.threshold -= 50;

    this.doScanning();
  }

  rotate(rotateVal: number) {
    if (rotateVal > 0 && rotateVal <= 90) {
      this.rotateImage = PrintRotation.Rot90;
    } else if (rotateVal > 90 && rotateVal <= 180) {
      this.rotateImage = PrintRotation.Rot180;
    } else if (rotateVal > 180 && rotateVal <= 270) {
      this.rotateImage = PrintRotation.Rot270;
    } else {
      this.rotateImage = PrintRotation.None;
    }
    this.doScanning();
  }
}
